import React, { createRef, useState, useRef, useEffect } from 'react'
import cx from 'classnames'
import { Textfield } from '@workboard/wobo-ui'

import Box from './box'

import useOnOutsideClick from '../../hooks/use-on-outside-click'

import './ui.scss'

const validTimeFormat = /^([0]\d|\d|[1]\d|[2][0-4]):([0-5]\d)\s?(?:AM|PM)?$/i;

const SelectTime = ({
  className,
  name,
  placeholder,
  initialValue = '',
  options = [],
  isDisabled,
  onChange,
  endAdornment = '',
}) => {
  const [inputValue, setInputValue] = useState(initialValue)
  const [isOpen, setIsOpen] = useState()
  const [isError, setIsError] = useState(false)

  const selectedRef = useRef()
  const inputRef = useRef()

  useEffect(() => {
    setInputValue(initialValue)
  }, [initialValue])

  const formatTime = (val) => {
    const timeSplit = val.replace(' ', ':').split(':')
    let hours = parseInt(timeSplit[0])
    let minutes = timeSplit[1]
    if (parseInt(minutes) != minutes) {
      setIsError(true)
    }
    let ampm = ''
    if (timeSplit[2]) {
      ampm = timeSplit[2]
    }
    if (hours > 12) {
      ampm = 'pm';
      hours -= 12;
    } else if (hours < 12) {
      if (!ampm) {
        ampm = 'am';
      }
      if (hours === 0) {
        hours = 12;
      }
    } else {
      if (!ampm) {
        ampm = 'pm';
      }
    }
    return `${hours}:${minutes} ${ampm}`
  }

  const handleSelect = (val) => {
    if (onChange) {
      onChange(val)
    }

    setInputValue(val)
    setIsOpen(false)
  }

  const handleFocus = () => {
    setIsOpen(true)
    setIsError(false)
  }

  const handleBlur = () => {
    if (!isOpen) return
    setIsOpen(false)
    if (inputValue && validTimeFormat.test(inputValue)) {
      setIsError(false)
      onChange(formatTime(inputValue))
    } else if (inputValue) {
      setIsError(true)
    }
  }

  const handleInputChange = (e) => {
    const { value } = e.target
    setInputValue(value)
  }

  const ref = useOnOutsideClick(handleBlur)

  const classes = cx(className, 'm-select', {
    'm-select--disabled': !!isDisabled,
    'm-select--error': isError,
  })

  return (
    <Box className={classes} ref={ref}>
      <Textfield
        className="m-select__input"
        ref={inputRef}
        name={name}
        placeholder={placeholder}
        defaultValue={inputValue}
        value={inputValue}
        autoComplete="off"
        isDisabled={!!isDisabled}
        endAdornment={endAdornment}
        onFocus={handleFocus}
        onChange={handleInputChange}
      />

      { isOpen
        && <Box className="m-select__dropdown">
          <ul className="m-select__options">
            { options.map((option) => {
              const isSelected = option === inputValue
              const itemClasses = cx('m-select__option', {
                'm-select__option--selected': isSelected,
              })
              return (
                <li
                  className={itemClasses}
                  onClick={() => handleSelect(option)}
                  ref={option === inputValue ? selectedRef : null}
                  key={option}
                >
                  {option}
                </li>
              )
            }) }
          </ul>
        </Box> }
    </Box>
  )
}

export default SelectTime
